import './Integrantes.css'
import React, { useState, useEffect } from 'react';
import { FormGroup, Table, Button } from 'reactstrap';
import { JournalBookmark, PersonFill } from 'react-bootstrap-icons';


const Integrantes = (props) => {
    const [listaIntegrantes, setListaIntegrantes] = useState(JSON.parse(localStorage.getItem('alunosTurma')));
    const [listaIntegrantesBackup, setListaIntegrantesBackup] = useState(JSON.parse(localStorage.getItem('alunosTurma')));

    const renderlistaIntegrantes = () => {
        let renderedList = [];
        for (let Integrante of listaIntegrantes) {
            renderedList.push(renderIntegranteSingle(Integrante));
        }
        return renderedList;
    }

    const filterList = (valorReferencia) => {
        setListaIntegrantes(listaIntegrantesBackup);
        if (valorReferencia) {
            let listaIntegrantesMod = listaIntegrantesBackup.filter(integrante => substringComparator(
                integrante.nomeAluno.toUpperCase().replaceAll(' ', ''), valorReferencia.trim().toUpperCase()));
            setListaIntegrantes(listaIntegrantesMod);
        }
    }

    const substringComparator = (valorBase, valorReferencia) => {
        let splitReferencia = valorReferencia.split(' ');
        let values = 0;
        for (let substring of splitReferencia) {
            if (valorBase.includes(substring)) {
                values++;
            }
        };
        return values === splitReferencia.length;
    }

    const renderIntegranteSingle = (integrante) => {
        return (
             <div className="tabelaItem" >
                <h8 className="tabelaComponent" onClick={() => props.putIntegrante(integrante["codigo"])}>
                    {integrante["nomeAluno"]}
                </h8>
                <div >
                    <PersonFill size={25} className="opcoesAlunos" onClick={() => props.putIntegrante(integrante["codigo"])} />
                    <JournalBookmark size={25} className="opcoesAlunos" onClick={() => props.putIntegranteRegistro(integrante["codigo"], false)} />
                    
                </div>
            </div>
        );
    }

    return (
        <>
            <h2 className="titulosPaginas">Integrantes da Turma</h2>
            <input type="text" placeholder="Buscar por Nome" className="pesquisaRapidaTurmas"
                onChange={(e) => filterList(e.target.value)} />
            <FormGroup>
                <div className="TabelaConfig">
                    <div hover={true} className="TabelaGer">
                        <div className="tabelaItem">
                            <h6 className="titulosTabelas">
                                NOME DO ALUNO
                            </h6>
                            <h6 className="titulosTabelas">
                                OPÇÕES
                            </h6>
                        </div>
                    </div>
                        {listaIntegrantes === null ? (<tr> <td> none </td></tr>) : (renderlistaIntegrantes())}
                </div>
            </FormGroup>
        </>
    );
}

export default Integrantes;